const GetUniqueProvince = () => {

    let province = [];

    let i = 0;
    let provinceObj = [{label: "กระบี่", value: "กระบี่"},
        {label: "กรุงเทพมหานคร", value: "กรุงเทพมหานคร"}, {label: "กาญจนบุรี", value: "กาญจนบุรี"},
        {label: "กาฬสินธุ์", value: "กาฬสินธุ์"}, {label: "กำแพงเพชร", value: "กำแพงเพชร"},
        {label: "ขอนแก่น", value: "ขอนแก่น"}, {label: "จันทบุรี", value: "จันทบุรี"},
        {label: "ฉะเชิงเทรา", value: "ฉะเชิงเทรา"}, {label: "ชลบุรี", value: "ชลบุรี"},
        {label: "ชัยนาท", value: "ชัยนาท"}, {label: "ชัยภูมิ", value: "ชัยภูมิ"},
        {label: "ชุมพร", value: "ชุมพร"}, {label: "ตรัง", value: "ตรัง"},
        {label: "ตราด", value: "ตราด"}, {label: "ตาก", value: "ตาก"},
        {label: "นครนายก", value: "นครนายก"}, {label: "นครปฐม", value: "นครปฐม"},
        {label: "นครพนม", value: "นครพนม"}, {label: "นครราชสีมา", value: "นครราชสีมา"},
        {label: "นครศรีธรรมราช", value: "นครศรีธรรมราช"}, {label: "นครสวรรค์", value: "นครสวรรค์"},
        {label: "นนทบุรี", value: "นนทบุรี"}, {label: "นราธิวาส", value: "นราธิวาส"},
        {label: "น่าน", value: "น่าน"}, {label: "บึงกาฬ", value: "บึงกาฬ"},
        {label: "บุรีรัมย์", value: "บุรีรัมย์"}, {label: "ปทุมธานี", value: "ปทุมธานี"},
        {label: "ประจวบคีรีขันธ์", value: "ประจวบคีรีขันธ์"}, {label: "ปราจีนบุรี", value: "ปราจีนบุรี"},
        {label: "ปัตตานี", value: "ปัตตานี"}, {label: "พระนครศรีอยุธยา", value: "พระนครศรีอยุธยา"},
        {label: "พะเยา", value: "พะเยา"}, {label: "พังงา", value: "พังงา"},
        {label: "พัทลุง", value: "พัทลุง"}, {label: "พิจิตร", value: "พิจิตร"},
        {label: "พิษณุโลก", value: "พิษณุโลก"}, {label: "ภูเก็ต", value: "ภูเก็ต"},
        {label: "มหาสารคาม", value: "มหาสารคาม"}, {label: "มุกดาหาร", value: "มุกดาหาร"},
        {label: "ยะลา", value: "ยะลา"}, {label: "ยโสธร", value: "ยโสธร"},
        {label: "ระนอง", value: "ระนอง"}, {label: "ระยอง", value: "ระยอง"},
        {label: "ราชบุรี", value: "ราชบุรี"}, {label: "ร้อยเอ็ด", value: "ร้อยเอ็ด"},
        {label: "ลพบุรี", value: "ลพบุรี"}, {label: "ลำปาง", value: "ลำปาง"},
        {label: "ลำพูน", value: "ลำพูน"}, {label: "ศรีสะเกษ", value: "ศรีสะเกษ"},
        {label: "สกลนคร", value: "สกลนคร"}, {label: "สงขลา", value: "สงขลา"},
        {label: "สตูล", value: "สตูล"}, {label: "สมุทรปราการ", value: "สมุทรปราการ"},
        {label: "สมุทรสงคราม", value: "สมุทรสงคราม"}, {label: "สมุทรสาคร", value: "สมุทรสาคร"},
        {label: "สระบุรี", value: "สระบุรี"}, {label: "สระแก้ว", value: "สระแก้ว"},
        {label: "สิงห์บุรี", value: "สิงห์บุรี"}, {label: "สุพรรณบุรี", value: "สุพรรณบุรี"},
        {label: "สุราษฎร์ธานี", value: "สุราษฎร์ธานี"}, {label: "สุรินทร์", value: "สุรินทร์"},
        {label: "สุโขทัย", value: "สุโขทัย"}, {label: "หนองคาย", value: "หนองคาย"},
        {label: "หนองบัวลำภู", value: "หนองบัวลำภู"}, {label: "อำนาจเจริญ", value: "อำนาจเจริญ"},
        {label: "อุดรธานี", value: "อุดรธานี"}, {label: "อุตรดิตถ์", value: "อุตรดิตถ์"},
        {label: "อุทัยธานี", value: "อุทัยธานี"}, {label: "อุบลราชธานี", value: "อุบลราชธานี"},
        {label: "อ่างทอง", value: "อ่างทอง"}, {label: "เชียงราย", value: "เชียงราย"},
        {label: "เชียงใหม่", value: "เชียงใหม่"}, {label: "เพชรบุรี", value: "เพชรบุรี"},
        {label: "เพชรบูรณ์", value: "เพชรบูรณ์"}, {label: "เลย", value: "เลย"}, 
        {label: "แพร่", value: "แพร่"}, {label: "แม่ฮ่องสอน", value: "แม่ฮ่องสอน"}];

    for(i=0;i<provinceObj.length;i++){
        if(!province.includes(provinceObj[i].value)){
            province.push(provinceObj[i].value);
        }

    }

    return { province, provinceObj };
}
 
export default GetUniqueProvince;